export function useStorage() {
  const uploadToPublicStorage = async (body) => {
    const formData = new FormData()
    formData.append('file', body.file)
    if (body.prefix) {
      formData.append('prefix', body.prefix)
    }
    const res = await $fetch(`/api/v1/storage/uploads/public`, {
      method: 'POST',
      body: formData,
    })
    return res
  }

  const getSupabaseSignedUploadUrl = async (body: {
    folderId: string
    fileName: string
    bucket?: string
  }) => {
    const res = await $fetch('/api/v1/storage/uploads/signed-url', {
      method: 'POST',
      body,
    })
    return res
  }

  const registerSupabaseFile = async (body: {
    folderId: string
    name: string
    storagePath: string
    uploadedBy?: string
    dropboxFileType?: string
    dropboxFileSize?: number
  }) => {
    const res = await $fetch('/api/v1/storage/files/register', {
      method: 'POST',
      body,
    })
    return res
  }

  const deleteSupabaseObject = async (storagePath: string) => {
    const res = await $fetch('/api/v1/storage/objects/delete', {
      method: 'POST',
      body: { storagePath },
    })
    return res
  }

  const uploadToSupabaseFolder = async (body: {
    folderId: string
    file: File
    uploadedBy?: string
  }) => {
    const signedUpload = await getSupabaseSignedUploadUrl({
      folderId: body.folderId,
      fileName: body.file.name,
    })

    const uploadResponse = await fetch(signedUpload.data.signedUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': body.file.type || 'application/octet-stream',
      },
      body: body.file,
    })

    if (!uploadResponse.ok) {
      throw new Error(`Failed to upload ${body.file.name}`)
    }

    try {
      const registerResponse = await registerSupabaseFile({
        folderId: body.folderId,
        name: body.file.name,
        storagePath: signedUpload.data.storagePath,
        uploadedBy: body.uploadedBy,
        dropboxFileType: body.file.type,
        dropboxFileSize: body.file.size,
      })
      return registerResponse?.data
    }
    catch (error) {
      // Compensate orphaned object (PUT succeeded, register failed).
      await deleteSupabaseObject(signedUpload.data.storagePath).catch(() => {})
      throw error
    }
  }

  return {
    uploadToPublicStorage,
    getSupabaseSignedUploadUrl,
    registerSupabaseFile,
    deleteSupabaseObject,
    uploadToSupabaseFolder,
  }
}
